<template>
  <div class="main-div">
    <div class="bg-main-color1" style="
        padding: 10px;
        color: #fff;
        display: flex;
        justify-content: space-between;
      ">
      <div>
        <strong>{{ label }}</strong>
        <span v-if="filterBreadcrumb" style="font-weight: normal; opacity: 0.9;"> - {{ filterBreadcrumb }}</span>
      </div>
      <button class="bg-main-color1" style="color: #fff" @click.prevent="toggle = !toggle" v-show="!toggle">
        Show
      </button>
      <button class="bg-main-color1" style="color: #fff" @click.prevent="toggle = !toggle" v-show="toggle">
        Hide
      </button>
    </div>
    
    <!-- Rest of your template content remains the same -->
    <div class="parent" v-show="toggle" v-if="
        filteredSurveyReport.length == 0 &&
        filteredTippingPointReport.length == 0 &&
        filteredPressurePointReport.length == 0 &&
        reportData.length > 0
      ">
      <h2>No report(s) available.</h2>
    </div>

    <!-- Survey Reports -->
    <div class="parent" v-show="toggle" v-if="filteredSurveyReport.length > 0">
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredSurveyReport"
        :key="report.survey_assignment_id"
      >
        <div>
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div v-else-if="report.stream_name == null && report.group_name != null">
            <p>{{ report.group_name }}</p>
          </div>
          <div v-else-if="report.stream_name == null && report.group_name == null">
            <p></p>
          </div>
          <div v-else-if="report.stream_name != null && report.group_name != null">
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3>For: {{ report.full_name }}</h3>
        </div>
        
        <!-- Survey Type Logos -->
        <div v-if="report.survey_type == 1">
          <img
            class="surveyLogo"
            src="../../public/survey_logo/big5_survey_logo.png"
          />
        </div>
        <div v-if="report.survey_type == 2">
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>
        <div v-if="report.survey_type == 3">
          <img
            class="surveyLogo"
            src="../../public/survey_logo/research_survey_logo.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-BEP-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_BEP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-GDP-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_GDP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-OCM-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_OCM.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-BEP-Cohort-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_BEP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-GDP-Cohort-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_GDP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-OCM-Cohort-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_OCM.png"
          />
        </div>
        <div v-if="report.survey_type == 5">
          <img
            class="surveyLogo"
            src="../../public/survey_logo/VFP_logo.png"
          />
        </div>
        
        <div
          v-if="
            report.survey_type == 6 &&
            report.report_file == 'Baseline-Board-Report.html'
          "
        >
          <img
            class="surveyLogo baseline"
            src="../../public/survey_logo/baseline_logo.png"
          />
        </div>

        <div
          v-if="
            report.survey_type == 6 &&
            report.report_file == 'Baseline-Individual-Report.html'
          "
        >
          <img
            class="surveyLogo baseline"
            src="../../public/survey_logo/baseline_logo.png"
          />
        </div>

        <!-- Coach Access Toggle -->
        <div>
          <p v-if="report.coach_access_granted == 1">Share status: Yes</p>
          <p v-if="report.coach_access_granted == 0">Share status: No</p>
          <label class="switch">
            <input
              type="checkbox"
              v-model="report.coach_access_granted"
              true-value="1"
              false-value="0"
              @change="
                coachPermission(
                  report.survey_assignment_id,
                  report.coach_access_granted
                )
              "
            />
            <span class="slider round"></span>
          </label>
        </div>

        <!-- 360 Eligibility -->
        <div
          class="tooltip"
          v-if="
            report.dropped_status == 0 &&
            report.not_eligible == 1 &&
            report.report_file.includes('360')
          "
        >
          Are you eligible for a report?
          <span class="tooltiptext"
            >- You must have 2 respondents <br /><br />
            - You must have a self assessment</span
          >
        </div>

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            report.not_eligible == 1 &&
            report.report_file.includes('360')
          "
          disabled
          label="Not eligible for a report"
          style="margin-top: 10px"
        />

        <!-- Interactive Report Buttons -->
        <a
          v-if="
            report.dropped_status == 0 &&
            report.not_eligible == 0 &&
            report.report_file.includes('360') &&
            report.hide_interactive_report == 0
          "
        >
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>
        <a
          v-if="
            report.dropped_status == 0 &&
            report.report_file.includes('5Step') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- VFP Report -->
        <a
          v-if="
            report.dropped_status == 0 && report.report_file.includes('VFP') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- Q-Sort BEP -->
        <a
          v-if="
            report.dropped_status == 0 &&
            report.report_file.includes('QSort-BEP') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- Q-Sort OCM -->
        <a
          v-if="
            report.dropped_status == 0 &&
            report.report_file.includes('QSort-OCM') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- Q-Sort GDP -->
        <a
          v-if="
            report.dropped_status == 0 &&
            report.report_file.includes('QSort-GDP') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- Global Button -->
        <a
          v-if="
            report.dropped_status == 0 &&
            !report.report_file.includes('5Step') &&
            !report.report_file.includes('360') &&
            !report.report_file.includes('QSort-GDP') &&
            !report.report_file.includes('QSort-OCM') &&
            !report.report_file.includes('QSort-BEP') && 
            !report.report_file.includes('VFP') &&
            !report.report_file.includes('Baseline') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- Baseline Reports -->
        <a
          v-if="
            report.dropped_status == 0 &&
            report.report_file.includes('Baseline') &&
            report.hide_interactive_report == 0
          "
        > 
          <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
            View Interactive Report
          </a>
        </a>

        <!-- PDF Button -->
        <a
          style="margin: 10px 0 10px 0"
          v-if="report.is_pdf_available === 1"
          class="btn-submit"
          @click="showReportPdf(report.report_template_id, report.survey_assignment_id)"
        >View Report PDF</a>

        <!-- Dropped Status -->
        <ButtonSubmit
          v-if="report.dropped_status == 1"
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />

        <!-- Admin Access -->
        <div class="tooltip" v-if="userId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the participant see in
            their report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>

        <a
          v-if="userId &&
          !report.report_file.includes('QSort-OCM')&&
          !report.report_file.includes('QSort-BEP')&&
          !report.report_file.includes('QSort-GDP')"
        > 
          <router-link class="btn-submit" :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData),
            }
          }" target="_blank">  
            Admin access to report
          </router-link>
        </a>

        <a
          v-if="userId &&
          report.report_file.includes('QSort-OCM')"
        > 
          <router-link class="btn-submit" :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData),
              QsortOCM: qsortOCM
            }
          }" target="_blank">  
            Admin access to report
          </router-link>
        </a>

        <a
          v-if="userId &&
          report.report_file.includes('QSort-BEP')"
        > 
          <router-link class="btn-submit" :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData),
              QsortBEP: qsortBEP
            }
          }" target="_blank">  
            Admin access to report
          </router-link>
        </a>

        <a
          v-if="userId &&
          report.report_file.includes('QSort-GDP')"
        > 
          <router-link class="btn-submit" :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData),
              QsortGDP: qsortGDP
            }
          }" target="_blank">  
            Admin access to report
          </router-link>
        </a>
      </div>
    </div>

    <!--tipping point report-->
    <div class="parent" v-show="toggle" v-if="filteredTippingPointReport.length > 0">
        <div
          class="child"
          style="background-color: #cdcdcd"
          v-for="report in filteredTippingPointReport"
          :key="report"
        >
        <div>
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3>For: {{ report.full_name }}</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/tipping_point_logo.png"
          />
        </div>
        <!-- <a href="#">View Sample Report</a> -->

        <div>
          <p v-if="report.coach_access_granted == 1">Share status: Yes</p>
          <p v-if="report.coach_access_granted == 0">Share status: No</p>
          <label class="switch">
            <input
              type="checkbox"
              v-model="report.coach_access_granted"
              true-value="1"
              false-value="0"
              @change="
                coachPermission(
                  report.survey_assignment_id,
                  report.coach_access_granted
                )
              "
            />
            <span class="slider round"></span>
          </label>
        </div>


        <a
          v-if="
            report.dropped_status == 0  &&
            report.hide_interactive_report == 0
          "
> 
              <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
                View Interactive Report
              </a>
            </a>

        <a
        style="margin: 10px 0 10px 0"
          v-if="report.is_pdf_available === 1"
          class="btn-submit"
          @click="showReportPdf(report.report_template_id, report.survey_assignment_id)"
          >View Report PDF</a
        >

        <ButtonSubmit
          v-if="
            report.dropped_status == 1 
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />
        <div class="tooltip" v-if="userId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the participant see in
            their report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="userId"
          > 
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData),
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
            </a>

        <button v-if="notShownToParticipantIds.length" class="not-shown-btn">
          Not available for Participants
        </button>

      </div>
    </div>

    <!--pressure point report-->
    <div class="parent" v-show="toggle" v-if="filteredPressurePointReport.length > 0">
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredPressurePointReport"
        :key="report"
      >
        <div>
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3>For: {{ report.full_name }}</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/pressure_point_logo.png"
          />
        </div>
        <!-- <a href="#">View Sample Report</a> -->
        
        <div>
          <p v-if="report.coach_access_granted == 1">Share status: Yes</p>
          <p v-if="report.coach_access_granted == 0">Share status: No</p>
          <label class="switch">
            <input
              type="checkbox"
              v-model="report.coach_access_granted"
              true-value="1"
              false-value="0"
              @change="
                coachPermission(
                  report.survey_assignment_id,
                  report.coach_access_granted
                )
              "
            />
            <span class="slider round"></span>
          </label>
        </div>

        <a
          v-if="
            report.dropped_status == 0  &&
            report.hide_interactive_report == 0
          "
          > 
              <a class="btn-submit" :href="getReportUrl(report)" target="_blank">  
                View Interactive Report
              </a>
            </a>

        <a 
          style="margin: 10px 0 10px 0"
          v-if="report.is_pdf_available === 1"
          class="btn-submit"
          @click="showReportPdf(report.report_template_id, report.survey_assignment_id)"
          >View Report PDF</a
        >
        
        <ButtonSubmit
          v-if="
            report.dropped_status == 1 
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />
        <div class="tooltip" v-if="userId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the participant see in
            their report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="userId"
          > 
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData),
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
            </a>

        <button v-if="notShownToParticipantIds.length" class="not-shown-btn">
          Not available for Participants
        </button>

      </div>
    </div>

  </div>
</template>

<script>

import ButtonSubmit from "./ButtonSubmit.vue";
import api from "../api/api";
import CryptoJS from "crypto-js";
import Swal from 'sweetalert2';

/* global Weglot */
export default {
  components: { ButtonSubmit },
  name: "HomeReports",
  data() {
    return {
      toggle: true,
      reportData: [],
      adminReportIds: [],
      participantReportIds: [],
      rand: "",
      coachAccess: "",
      reportId: "",
      qsortBEP: "BEP",
      qsortGDP: "GDP",
      qsortOCM: "OCM",
      setLoading: false,
      abortController: new AbortController(),  
    };
  },
  props: {
    userData: Object,
    brandData: Object,
    reportName: String,
    surveyName: String,
    dateTime: String,
    buttonLabel: String,
    label: String,
    buttonColor: String,
    userId: Number,
    country: String,
    sex: String,
    activeFilters: Object, // RECEIVE FILTERS FROM PARENT
  },
  async mounted() {
    console.log('HomeReports mounted!');
    
    this.rand = Math.random()
    
    // Load report data
    if (this.userId) {
      this.reportId = this.userId;
      await this.loadAdminReports();
    } else {
      this.reportId = this.userData.ind_id;
      await this.loadParticipantReports();
    }
  },

  methods: {
    getReportUrl(report) {
      const currentLang = (window.Weglot && Weglot.getCurrentLang && Weglot.getCurrentLang()) || 'en';
      console.log('[HomeReports] getReportUrl - current lang:', currentLang, '| report:', report.report_file);
      const routeData = this.$router.resolve({
        name: 'MyReport',
        query: { 
          reportData: this.encrypt(JSON.stringify(report)),
          userData: JSON.stringify(this.userData),
          brandData: JSON.stringify(this.brandData),
          lang: currentLang,
          // Add Q-sort based on report type
          ...(report.report_file.includes('QSort-BEP') && { QsortBEP: this.qsortBEP }),
          ...(report.report_file.includes('QSort-OCM') && { QsortOCM: this.qsortOCM }),
          ...(report.report_file.includes('QSort-GDP') && { QsortGDP: this.qsortGDP }),
        }
      });
      return routeData.href;
    },
    async loadAdminReports() {
      try {
        const res = await api.get(`get-participant-reports-by-admin/${this.reportId}`, {  
          signal: this.abortController.signal,  
        });
        
        this.reportData = res.data;
        this.adminReportIds = this.reportData.map(r => r.survey_assignment_id);
        await this.getParticipantReports();
        await this.loadReportDetails();
      } catch (error) {
        console.error('Error loading admin reports:', error);
      }
    },

    async loadParticipantReports() {
      try {
        const res = await api.get(`get-participant-reports/${this.reportId}`, {  
          signal: this.abortController.signal,  
        });
        
        this.reportData = res.data;
        this.participantReportIds = this.reportData.map(r => r.survey_assignment_id);
        await this.loadReportDetails();
      } catch (error) {
        console.error('Error loading participant reports:', error);
      }
    },

    async loadReportDetails() {
      if (this.reportData.length === 0) return;

      // Run all report detail fetches in parallel instead of sequentially
      await Promise.allSettled(this.reportData.map(async (reportItem) => {
        try {
          const eligibilityRes = await api.get(
            `get-not-eligible360/${reportItem.survey_assignment_id}`,
            { signal: this.abortController.signal }
          );
          const existData = eligibilityRes.data;
          if (existData && existData.survey_assignment_id === reportItem.survey_assignment_id) {
            reportItem.not_eligible = existData.not_eligible;
          }
        } catch (error) {
          if (error.message !== 'canceled') {
            console.error('Error loading eligibility:', error);
          }
        }

        try {
          const surveyRes = await api.get(
            `survey-results-sex-country/${reportItem.survey_assignment_id}`,
            { signal: this.abortController.signal }
          );
          const existData = surveyRes.data.find(
            r => r.survey_assignment_id === reportItem.survey_assignment_id
          );
          if (existData) {
            reportItem.gender = existData.gender;
            reportItem.country = existData.country;
          }
        } catch (error) {
          if (error.message !== 'canceled') {
            console.error('Error loading survey details:', error);
          }
        }
      }));
    },
        
    applyFilters(reports) {
      if (!this.activeFilters) {
        return reports;
      }

      return reports.filter(report => {
        if (this.activeFilters.organization && 
            report.org_id !== this.activeFilters.organization.id) {
          return false;
        }

        if (this.activeFilters.subOrganization && 
            report.suborg_id !== this.activeFilters.subOrganization.id) {
          return false;
        }

        if (this.activeFilters.program && 
            report.program_id !== this.activeFilters.program.id) {
          return false;
        }

        if (this.activeFilters.iteration && 
            report.iteration_id !== this.activeFilters.iteration.id) {
          return false;
        }

        if (this.activeFilters.stream && 
            report.stream_id !== this.activeFilters.stream.id) {
          return false;
        }

        if (this.activeFilters.group && 
            report.group_id !== this.activeFilters.group.id) {
          return false;
        }

        if (this.activeFilters.searchQuery) {
          const query = this.activeFilters.searchQuery.toLowerCase();
          const fullName = report.full_name?.toLowerCase() || '';
          const programName = report.program_name?.toLowerCase() || '';
          const iterationName = report.iteration_name?.toLowerCase() || '';
          const reportName = report.report_template_name?.toLowerCase() || '';
          
          if (!fullName.includes(query) && 
              !programName.includes(query) && 
              !iterationName.includes(query) &&
              !reportName.includes(query)) {
            return false;
          }
        }

        return true;
      });
    },

    async getParticipantReports() {
      let _computedReportId = this.userId ? this.userId : this.userData.ind_id;
      
      try {
        const response = await api.get(`get-participant-reports/${_computedReportId}`, {
          signal: this.abortController.signal,
        });
        this.participantReportIds = response.data.map(r => r.survey_assignment_id);
      } catch (error) {
        console.error('Error fetching participant reports:', error);
        this.participantReportIds = [];
      }
    },

    encrypt(src) {
      let passphrase = "rptData"
      return CryptoJS.AES.encrypt(src, passphrase).toString();
    },

    async coachPermission(survey_assignment_id, coach_access_granted) {
      await api.put(
        `survey-assignment/coach-access-granted/${survey_assignment_id}`,
        {
          coach_access_granted: coach_access_granted,
        }
      );
    },
    
    async showReportPdf(reportTemplateId, surveyAssignmentId){
      this.setLoading = true
      let url = null
      if(this.setLoading === true){
        this.showPdfAlert()
      }
      
      try {
        const requestBody = {
          report_template_id: reportTemplateId,
          survey_assignment_id: surveyAssignmentId,
          downloaded_by: this.userData.first_name + " " + this.userData.last_name,
        };

        const response = await api.post('/get-pdf-content', requestBody, {
          responseType: 'blob',
          signal: this.abortController.signal,
        });
           
        const blob = new Blob([response.data], { type: 'application/pdf' });
        url = window.URL.createObjectURL(blob);
       
        if(url !== null){
          window.open(url, '_blank');
          this.setLoading = false
          if(this.setLoading === false){
            this.hidePdfAlert()
          }
        }
      } catch (error) {
        if(error.message=='canceled') {
          return
        } else {
          Swal.fire({
            title: '',
            text: 'A pdf is not available. TalentSage Support have been notified and will contact you when the issue has been resolved',
            icon: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#3085d6',
            allowOutsideClick: false,
          })
          console.error('Error downloading PDF:', error);
        }
      }
    },

    async showPdfAlert(){
      Swal.fire({
        title: "Preparing your pdf, please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },

    async hidePdfAlert(){
      Swal.close()
    }
  },

  computed: {
    filterBreadcrumb() {
      if (!this.activeFilters) {
        return '';
      }

      const parts = [];
      
      // Organization
      if (this.activeFilters.organization) {
        parts.push(this.activeFilters.organization.name);
        
        // Sub-Organization
        if (this.activeFilters.subOrganization) {
          parts.push(this.activeFilters.subOrganization.name);
          
          // Program
          if (this.activeFilters.program) {
            parts.push(this.activeFilters.program.name);
            
            // Iteration
            if (this.activeFilters.iteration) {
              parts.push(this.activeFilters.iteration.name);
              
              // Stream
              if (this.activeFilters.stream) {
                parts.push(this.activeFilters.stream.name);
                
                // Group
                if (this.activeFilters.group) {
                  parts.push(this.activeFilters.group.name);
                } else {
                  const groupCount = this.activeFilters.stream.groups?.length || 0;
                  if (groupCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const streamCount = this.activeFilters.iteration.streams?.length || 0;
                if (streamCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const iterationCount = this.activeFilters.program.iterations?.length || 0;
              if (iterationCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const programCount = this.activeFilters.subOrganization.programs?.length || 0;
            if (programCount > 1) {
              parts.push('many');
            }
          }
        } else {
          const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
          if (subOrgCount > 1) {
            parts.push('many');
          }
        }
      }
      
      return parts.join(' / ');
    },
    filteredSurveyReport() {
      return this.applyFilters(this.surveyReport.filter(r => !r.archived_status));
    },

    filteredTippingPointReport() {
      return this.applyFilters(this.tippingPointReport.filter(r => !r.archived_status));
    },

    filteredPressurePointReport() {
      return this.applyFilters(this.pressurePointReport.filter(r => !r.archived_status));
    },

    notShownToParticipantIds() {
      if (!this.userId) {
        return [];
      }
      return this.adminReportIds.filter(
        id => !this.participantReportIds.includes(id)
      );
    },
    
    surveyReport() {
  return this.reportData
    .filter(el => {
      return (
        !el.report_file.includes('TIPping') &&
        !el.report_file.includes('Pressure')
      );
    })
    .sort((a, b) => b.survey_assignment_id - a.survey_assignment_id);
    },

    tippingPointReport() {
      return this.reportData
        .filter(el => el.tag_type == "has_tipping_point")
        .sort((a, b) => b.survey_assignment_id - a.survey_assignment_id);
    },

    pressurePointReport() {
      return this.reportData
        .filter(el => el.tag_type == "has_pressure_point")
        .sort((a, b) => b.survey_assignment_id - a.survey_assignment_id);
    },
  },
  
  beforeUnmount() {
    console.log('HomeReports unmounting, cleaning up...');
    this.abortController.abort();  
  }, 
};
</script>

<style scoped>
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.bg-main-color1 {
  border-radius: var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem) 0 0;
  font-size: var(--label-md-size, 12px);
  letter-spacing: var(--label-md-tracking, 0.05em);
  text-transform: uppercase;
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-sm, 16px);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-top: none;
  border-radius: 0 0 var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem);
}
.child {
  background: var(--card-bg, #ffffff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 250px;
  max-width: 250px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.child:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.child-submitted {
  background: var(--surface-container-low, #eff4ff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 205px;
  max-width: 205px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
}
.child-submitted:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.btn-submit {
  text-decoration: none;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}
.surveyLogo { width: 150px; height: auto; }

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: var(--outline, #737781);
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: var(--inverse-surface, #213145);
  color: var(--inverse-on-surface, #eaf1ff);
  text-align: center;
  border-radius: var(--radius, 0.25rem);
  padding: 8px 6px;
  position: absolute;
  z-index: 1;
  font-size: 12px;
}
.tooltip:hover .tooltiptext { visibility: visible; }

.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: var(--outline-variant, #c3c6d1);
  transition: 0.3s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.3s;
}
input:checked + .slider { background-color: var(--primary, #002955); }
input:focus + .slider { box-shadow: 0 0 1px var(--primary, #002955); }
input:checked + .slider:before { transform: translateX(24px); }
.slider.round { border-radius: 28px; }
.slider.round:before { border-radius: 50%; }

@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
}
input, select, option, textarea {
  border: 1px solid var(--outline-variant, #c3c6d1);
  font-family: var(--font-family, 'Inter', sans-serif);
}
.pdf-url { cursor: pointer; }
.baseline { width: 60%; margin-top: 10px; }

.not-shown-btn {
  margin-top: 10px;
  background: #1e7d3a;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: var(--radius, 0.25rem);
  font-family: var(--font-family, 'Inter', sans-serif);
}

.reports-page-wrapper { position: relative; min-height: 100vh; }
.reports-content-area { transition: none; padding: 0; margin-left: 0; }

@media only screen and (max-width: 768px) {
  .reports-content-area { margin-left: 60px; }
}
</style>
